import React, { memo, useEffect, useState } from 'react';

import { RiPlayCircleFill, MdOutlineArrowRightAlt } from '../../../../components/icons';
import './css/style.scss';
import { reactHtmlParser, specialityPopOver } from '../../../../common/common';
import useRedirect from '../../../customHooks/useRedirect';
import LazyImage from '../../../CustomLibraries/LazyImage';
import { grand_rounds_static_image } from '../../../../common/assets.common';
import { isMobile } from 'react-device-detect';
const RelatedGrCard = ({ data, click, gtmTagVariable = '' }) => {
  const { redirectTo } = useRedirect();
  return (
    <div className="w-100 float-start archVideoSmallCard position-relative mb-3">
      {/* <div className="smallCardGraph position-absolute top-0 end-0 h-100" style={{ "borderColor":"#355fd3"}}></div> */}
      <div className="w-100 float-start smallCardIn position-relative z-1 d-flex justify-content-between align-items-center">
        <div
          className="smallCardPic cursorPointer position-relative overflow-hidden"
          onClick={click}
        >
          <LazyImage
            src={data?.image}
            className="object-fit-cover w-100 h-100 float-start"
            alt="image"
            fallback_image={grand_rounds_static_image}
          />
          {/* <RiPlayCircleFill customClass="text-white translate_both fs-36" /> */}

          <div
            className={`overlay bg-black bg-opacity-25 ${gtmTagVariable}_relatedGrCard`}
            // id={`${gtmTagVariable}_relatedGrCard_image_${data.type_id}`}
          ></div>
          <span className="d-block fw-semibold text-white relatedTag position-absolute bottom-0 start-0 w-100 p-1 text-center z-1 fs-6 bg-black bg-opacity-75 text-nowrap">
            {isMobile ? 'GR' : 'Grand Round'}
          </span>
        </div>
        <div className="smallCardRight text-start ps-3">
          <span className="d-flex align-items-center gap-2 text-black fw-normal fs-5 smallCardSpeclty">
            <span
              className={`cursorPointer ${gtmTagVariable}_relatedGrCard_speciality`}
              // id={`${gtmTagVariable}_relatedGrCard_speciality_${data?.specialities_ids_and_names[0]?.id}`}
              onClick={() => {
                if (data?.specialities_ids_and_names) {
                  redirectTo(
                    'Speciality',
                    data?.specialities_ids_and_names[0]?.id,
                    data?.specialities_ids_and_names[0]?.name
                  );
                }
              }}
            >
              {data?.specialities?.split(',')[0]}
            </span>
            {specialityPopOver(data.specialities)}
          </span>
          <h4
            className={`text-black fs-4 fw-medium cursorPointer ${gtmTagVariable}_relatedGrCard`}
            // id={`${gtmTagVariable}_relatedGrCard_title_${data.type_id}`}
            onClick={click}
          >
            {reactHtmlParser(
              data?.title?.length > 50 ? data?.title?.substring(0, 50) + '...' : data?.title
            )}
          </h4>
          <span
            className={`cursorPointer text-black fw-medium smallCardRight_a fs-5 d-flex ${gtmTagVariable}_relatedGrCard`}
            onClick={click}
          >
            View Details{' '}
            <MdOutlineArrowRightAlt
              gtmTagVariable={`${gtmTagVariable}_relatedGrCard`}
              customClass={`fs-16 ms-2 ${gtmTagVariable}_relatedGrCard_viewDetails`}
            />
          </span>
          {/* <h5 className="text-dark fs-5 smallCardChanel mt-1">{ReactHtmlParser(data.answer)[0].substring(0,10)}</h5> */}
        </div>
      </div>
    </div>
  );
};

export default memo(RelatedGrCard);
